export const transformShipmentItemDto = _ref => {
  let {
    name,
    image_url
  } = _ref;
  return {
    name,
    imageUrl: image_url
  };
};
export const transformShipmentItemDtos = shipmentItems => shipmentItems.map(transformShipmentItemDto);